import React from "react";

// Premium Aalam Al-Itarat logo: Saudi-green banner accent above a bold tyre
// with a sleek road running through it. Arabic + English wordmark.
export const LogoMark = ({ size = 44 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    {/* green banner accent */}
    <rect x="8" y="3" width="48" height="6" rx="1" fill="#006C35" />
    {/* tyre outer */}
    <circle cx="32" cy="38" r="21" fill="#0a0a0a" stroke="#EAB308" strokeWidth="3" />
    {/* tread ticks */}
    {Array.from({ length: 24 }).map((_, i) => {
      const a = (i * 15 * Math.PI) / 180;
      const x1 = 32 + Math.cos(a) * 21;
      const y1 = 38 + Math.sin(a) * 21;
      const x2 = 32 + Math.cos(a) * 17.5;
      const y2 = 38 + Math.sin(a) * 17.5;
      return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#3f3f46" strokeWidth="1.4" />;
    })}
    {/* inner hub */}
    <circle cx="32" cy="38" r="9" fill="#121212" stroke="#52525b" strokeWidth="1.5" />
    {/* sleek road through center */}
    <path d="M6 44 L58 32" stroke="#EAB308" strokeWidth="4" strokeLinecap="round" />
    <path d="M14 43 L26 40" stroke="#050505" strokeWidth="1.4" strokeDasharray="3 3" />
    <path d="M38 36 L52 33" stroke="#050505" strokeWidth="1.4" strokeDasharray="3 3" />
  </svg>
);

export const Logo = ({ size = 44, stacked = false }) => (
  <div className="flex items-center gap-3" data-testid="site-logo">
    <LogoMark size={size} />
    <div className="flex flex-col leading-none">
      <span className="font-ar-head font-bold text-lg text-white" style={{ letterSpacing: "0.02em" }}>
        عالم الإطارات
      </span>
      <span className="font-en-head font-extrabold tracking-widest text-[10px] text-[#EAB308] uppercase">
        Aalam Al-Itarat
      </span>
    </div>
  </div>
);

export default Logo;
